export default "<div class=\"item-tooltips\" infoTooltip [text]=\"text\">\n<span class=\"tooltip-symbol\">?</span>\n</div>\n";